export const SEARCH_SOURCE = 'home_hero';
